import { registerRemotes } from '@module-federation/enhanced/runtime';

fetch('/glass.manifest.json')
  .then((res) => res.json())
  .then((definitions) => {
    const remotes = definitions.remotes;
    const remoteDefinitions =
      remotes?.map((remote: { __id: any; remoteUrl: any }) => {
        return {
          name: remote.__id,
          entry: remote.remoteUrl,
        };
      }) ?? [];

    if (remoteDefinitions.length > 0) {
      registerRemotes(remoteDefinitions, { force: true });
    }
  })
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
